const api = '/api/v1/omatome.php';
import axios from 'axios';
export const omatomeRepository =  {
    methods: {
        async get(item){
            return  axios.get(api)
        },
        async Set(item){
            return  axios.post(api,item)
        }
    }
};

